import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from 'antd';
import WizardContent from '~/layouts/WizardContent';
import LeftLayout from '~/layouts/LeftLayout';
import BottomLeftActions from '~/layouts/BottomLeftActions';
import features from '~/constants/features';
import { SubmitStageImg } from '~/img';
import WizardContinueButton from '~/layouts/WizardContinueButton';
import { useProceedStep } from '~/controllers/wizard';
import { proceedFailedOnboarding } from '~/api/onboarding';
import AutomatedOnboardingErrors from '~/pages/ksa/completion/components/AutomatedOnboardingErrors';
import CompletionContainer from '~/pages/ksa/completion/components/CompletionContainer';

const TechFailedOnboarding: FC = () => {
  const { t } = useTranslation('ksaCompletion');
  const [tc] = useTranslation('common');
  const proceed = useProceedStep(proceedFailedOnboarding);

  const onClick = () => {
    proceed.mutateAsync().catch((e) => {
      console.error(`failed to submit; error:`, e);
    });
  };

  return (
    // <WizardContent
    //   left={
    //     <LeftLayout>
    //       <BottomLeftActions contactUsUrl={features.contactUsLinkHardDecline} />
    //     </LeftLayout>
    //   }
    //   content={
    <CompletionContainer className="Completed">
      <Typography.Title>{t('Automated onboarding failed')}</Typography.Title>
      <Typography.Paragraph className="Completion-Paragraph">
        {t(
          'This application was failed to be registered in back office systems. Please contact technical support and proceed with manual onboarding.'
        )}
      </Typography.Paragraph>
      <AutomatedOnboardingErrors />
      <SubmitStageImg className="Completion-Img" />
    </CompletionContainer>
    //   }
    //   right={
    //     <WizardContinueButton
    //       id="failedOnboarding_confirmButton"
    //       onClick={onClick}
    //       loading={proceed.isLoading}
    //     >
    //       {tc('Continue')}
    //     </WizardContinueButton>
    //   }
    // />
  );
};

export default TechFailedOnboarding;
